import { BackednResponse } from "@shared/lib/types";
import { IInvoiceById } from "@shared/lib/types/accounting";

import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { INVOICES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";

export function useGetInvoiceById(id: string, enabled: boolean = false) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IInvoiceById>
  >({
    queryKey: [...INVOICES_QUERY_KEY, id],
    queryFn: () => AccountingService.getInvoiceById(id),
    enabled: !!id && enabled,
  });
  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    invoice: data?.data,
    isLoading,
    isError,
    error,
  };
}
